/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidateTokenResponse
 */
export interface ValidateTokenResponse {
    /**
     * True if token is genuine and has not expired yet, false otherwise.
     * @type {boolean}
     * @memberof ValidateTokenResponse
     */
    valid: boolean;
    /**
     * If the token is invalid, this field contains the reason.
     * @type {ValidateTokenResponseInvalidityReasonEnum}
     * @memberof ValidateTokenResponse
     */
    invalidity_reason?: ValidateTokenResponseInvalidityReasonEnum;
    /**
     * JWT token validity. This value is not present if the token is not valid (valid field == false).
     * @type {number}
     * @memberof ValidateTokenResponse
     */
    expires_in_seconds?: number;
    /**
     * Token expiration time in UTC. This value is not present if token is not valid (valid field == false) or expired.
     * @type {Date}
     * @memberof ValidateTokenResponse
     */
    expires_at?: Date;
}


/**
 * @export
 */
export const ValidateTokenResponseInvalidityReasonEnum = {
    InvalidTokenContent: 'invalid_token_content',
    Expired: 'expired',
    InvalidIssuer: 'invalid_issuer',
    NotEnoughFactors: 'not_enough_factors',
    PersonNotActive: 'person_not_active'
} as const;
export type ValidateTokenResponseInvalidityReasonEnum = typeof ValidateTokenResponseInvalidityReasonEnum[keyof typeof ValidateTokenResponseInvalidityReasonEnum];


/**
 * Check if a given object implements the ValidateTokenResponse interface.
 */
export function instanceOfValidateTokenResponse(value: object): value is ValidateTokenResponse {
    if (!('valid' in value) || value['valid'] === undefined) return false;
    return true;
}

export function ValidateTokenResponseFromJSON(json: any): ValidateTokenResponse {
    return ValidateTokenResponseFromJSONTyped(json, false);
}

export function ValidateTokenResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateTokenResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'valid': json['valid'],
        'invalidity_reason': json['invalidity_reason'] == null ? undefined : json['invalidity_reason'],
        'expires_in_seconds': json['expires_in_seconds'] == null ? undefined : json['expires_in_seconds'],
        'expires_at': json['expires_at'] == null ? undefined : (new Date(json['expires_at'])),
    };
}

export function ValidateTokenResponseToJSON(json: any): ValidateTokenResponse {
    return ValidateTokenResponseToJSONTyped(json, false);
}

export function ValidateTokenResponseToJSONTyped(value?: ValidateTokenResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'valid': value['valid'],
        'invalidity_reason': value['invalidity_reason'],
        'expires_in_seconds': value['expires_in_seconds'],
        'expires_at': value['expires_at'] == null ? value['expires_at'] : value['expires_at'].toISOString(),
    };
}

